<template>
    <v-layout align-start>
        <v-flex>
             <v-data-table
                :headers="headers"
                :items="catCatArea"
                :search="search"
                class="elevation-1">
                <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Area</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" 
                        v-model="search" append-icon="search" 
                        label="Busqueda" single-line hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <!-- ********** -->
                    <v-dialog v-model="dialog" fullscreen 
                        hide-overlay transition="dialog-bottom-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" 
                                dark v-on="on"
                                @click="newItem"
                                outlined>Crear Area</v-btn>
                        </template>
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-btn icon dark @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-toolbar-title><span class="headline">Area</span></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn dark text @click="newItem">Limpiar Controles</v-btn>
                                </v-toolbar-items>
                                <!-- <v-btn class="ma-2" @click="Limpiar()" outlined color="indigo">Limpiar Controles</v-btn> -->
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn 
                                        @click="saveItem"
                                        dark text>
                                        Grabar
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>                        
                            <v-list three-line subheader>
                                <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-text-field
                                                label="Descripcion"
                                                v-model="editedItem.descripcion"
                                                outlined>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list>
                        </v-card>
                        <v-divider></v-divider>
                    </v-dialog>
                    <!-- ********** -->
                    </v-toolbar>
                </template>
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.idCatArea">
                            <td>
                                <div>
                                    <v-icon small class="mr-2" @click="editItem(item)">
                                        edit
                                    </v-icon>
                                    <v-icon small @click="deleteItem(item)">
                                        delete
                                    </v-icon>
                                </div>
                            </td>
                            <td>{{ item.descripcion }}</td>
                        </tr>
                    </tbody>
                </template> 
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Resetear</v-btn>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>  

<script>
import moment from 'moment'
export default {
    name: 'comunicadousuario',
    components: {
    },
    data () {
        return {
            catCatArea: [],
            editedItem: {},
            consultaDto: {
                Skip: 0,
                Take: 100,
                descending: true,
                sortBy: '',
                search: '',
                extraParam: '3'
            },
            
            dialog: false,
            headers: [
                { text: 'Acciones', value: '' },
                { text: 'Descripcion', value: 'descripcion' }
            ],            
            files: null,
            search: ''
        }
    },
    computed: { },
    watch: { },
    created () { },
    mounted () {
        this.Default()
    },
    filters: {
        formatDate(date){
            return moment(date).format('L')
        }
    },
    methods: {
        Default () {
            let me = this            
            me.$store.dispatch('setIsBusy', true)
            me.GetMensajeUsuario()            
        },        
        GetMensajeUsuario () {
            var me = this
            me.$axios.post('api/Area/Get', me.consultaDto)
                .then(r => {
                    if (r.data.exito) {
                        me.catCatArea = r.data.datos
                    }
                    // this.$root.Mensaje(r.data.mensaje)
                    me.$store.dispatch('setIsBusy', false)
                })
                .catch(e => { console.log(e) })
        },
        newItem () {
            let me = this
            me.$axios.get('api/Area/New')
                .then(r => {
                    me.editedItem = r.data
                })
                .catch(e => { console.log(e) })
        },
        editItem (item) {
            this.editedItem = item
            this.dialog = true
        },
        deleteItem (item) {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            me.$axios.get('api/Area/Delete?idArea=' + item.idArea)
                .then(s => {
                    if(s.data.exito) {
                        me.$root.Mensaje('Area eliminada')
                    } else {
                        me.$root.Mensaje(s.data.mensaje)
                    }
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                    me.GetMensajeUsuario();
                })
                .catch(e => {                     
                    this.$root.Mensaje(e)
                })
        },
        saveItem () {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            var js = {
                "idArea": me.editedItem.idArea,
                "descripcion": me.editedItem.descripcion
            }
            console.log(js)
            me.$axios.post('api/Area/Save', js)
                .then(s => {
                    if(s.data.exito) {
                        me.$root.Mensaje('Area creada')
                        me.GetMensajeUsuario()
                    } else {
                        me.$root.Mensaje('s.data.mensaje')
                    }
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                })
                .catch(e => { 
                    console.log(e)
                    this.$root.Mensaje(e)
                })
        }
    }
}
</script>
